/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export * from './update-profile-component.service';
export * from './update-profile.component';
export * from './update-profile.module';
